<template>
  <!-- overflow-y-scroll -->
  <div
    id="right"
    class="lg:block hidden lg:w-1/3 h-full border-l border-lighter py-2 px-6 overflow-y-scroll relative float-left"
  >
    <input
      class="pl-12 rounded-full w-full p-2 bg-lighter text-sm focus:outline-none"
      type="search"
      placeholder="Search Twiteer"
    />
    <i class="fas fa-search absolute left-0 top-0 mt-5 ml-12 text-sm text-light"></i>
    <div class="w-full rounded-lg bg-lightest mt-5">
      <!-- Trends now  -->
      <div class="flex items-center justify-between p-3">
        <p class="text-lg font-bold">Trends for you</p>
        <i class="fas fa-cog text-lg text-blue"></i>
      </div>
      <button
        v-for="(trend, index) in trends"
        :key="index"
        class="w-full flex justify-between hover:bg-lighter p-3 border-t border-lighter focus:outline-none"
      >
        <div>
          <p class="text-sm text-left leading-tight text-dark">{{ trend.top }}</p>
          <p class="font-bold text-left leading-tight">{{ trend.title }}</p>
          <p class="text-left leading-tight text-dark">{{ trend.bottom }}</p>
        </div>
        <i class="fas fa-angle-down text-lg text-dark"></i>
      </button>

      <button
        class="p-3 w-full hover:bg-lighter text-left text-blue border-top border-lighter rounded-b-lg focus:outline-none"
      >Show more</button>
    </div>
    <!-- who to follow  -->
    <div class="w-full rounded-lg bg-lightest mt-5 mb-3">
      <div class="p-3">
        <p class="text-lg font-bold">Who to follow</p>
      </div>
      <!-- following list to follow -->
      <button
        v-for="(friend , index) in friends"
        :key="index"
        class="w-full flex hover:bg-lighter p-3 border-t border-lighter focus:outline-none"
      >
        <img
          :src="require(`@/assets/images/${ friend.src}`)"
          alt="profile.pic"
          class="w-12 h-12 rounded-full border border-lighter"
        />
        <div class="hidden lg:block ml-4">
          <a href="#" class="text-sm font-bold leading-tight hover:underline ">{{ friend.name }}</a>
          <p class="text-sm leading-tight float-left b-0 absolute">{{ friend.handle }}</p>
        </div>
        <button
          class="ml-auto text-blue text-sm py-1 px-4 rounded-full border-2 border-blue hover:bg-lightblue focus:outline-none"
        >Follow</button>
      </button>

      <button
        class="p-3 w-full hover:bg-lighter text-left text-blue border-top border-lighter rounded-b-lg focus:outline-none"
      >Show more</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Right",

  data() {
    return {
      trends: [
        {
          top: "Trending in BD",
          title: "Evaly",
          bottom: "Trending with: Digital Faad",
        },
        { top: "Music", title: "We Won", bottom: "135k Tweets" },
        { top: "Pop", title: "Blue Ivy", bottom: "65k Tweets" },        
        { top: "Trending in US", title: "Denim Day", bottom: "85k Tweets" },
        { top: "Trending", title: "When Beyonce", bottom: "25.8k Tweets" },
        { top: "Gaye Holud", title: "Bike Riding in holud", bottom: "5k Tweets" },
        { top: "Ecommerce", title: "Hold account", bottom: "2k Tweets" },
      ],

      friends: [
        { src: "elon.jpg", name: "Elon Mask", handle: "@teslaBoy" },
        { src: "ranbeer.jpg", name: "Ranveer Kapoor", handle: "@ranbeerPboy" },
        { src: "sakib.jpg", name: "Sakib Al Hasan", handle: "@sakibTiger" },
        { src: "raselevaly.jpg", name: "Muhammad Rasel ", handle: "@raselevaly" },
      ],
    };
  },
};
</script> 